@let screenGtSm = media.state()['gt-sm'];
@if (filesFormMode() !== 'edit' && filesFormMode() !== 'add') {
    <div class="deposit-section-description" @heightInAnimation @heightOutAnimation>
        <span>{{ 'research.files.subtitle.part1' | customTranslate }}</span>
        @if (sectionOrder().includes(fieldType.Links)) {
            <span>&nbsp;{{ 'research.files.subtitle.part2' | customTranslate }}</span>
            <button mat-button color="primary" (click)="onAddLink()" type="button">
                @if (multiple()) {
                    <span>{{ 'research.files.link' | customTranslate }}</span>
                }
            </button>
        }
    </div>

    <mulo-file-drop
        @heightInAnimation
        @heightOutAnimation
        (output)="addNewFile($event)"
        [multiple]="multiple()"
        class="file-drop"
        [multiFilesDropLabel]="'researcherDeposit.filesAndLinks.dropzone.multiple' | translate"
        [singleFileDropLabel]="'researcherDeposit.filesAndLinks.dropzone.single' | translate"
        [multiDropActionLabel]="'researcherDeposit.filesAndLinks.action.multiple' | translate"
        [singleDropActionLabel]="'researcherDeposit.filesAndLinks.action.single' | translate"
        [multiSelectBtnLabel]="'researcherDeposit.filesAndLinks.select.multiple' | translate"
        [singleSelectBtnLabel]="'researcherDeposit.filesAndLinks.select.single' | translate"
        [fileDropLimitMsg]="'researcherDeposit.filesAndLinks.limit.fileDrop' | translate"
        [typeChangedLimitMsg]="'researcherDeposit.filesAndLinks.limit.typeChanged' | translate"
        [confirmFileReplaceMsg]="'researcherDeposit.filesAndLinks.confirmReplace' | translate"
        [invalidFilesHeaderLabel]="'researcherDeposit.filesAndLinks.invalidFilesHeader' | translate"
    ></mulo-file-drop>
}
@for (section of sectionOrder(); track section) {
    @if (section === fieldType.Files) {
        @let fileLabels =
            {
                displayName: {
                    label: 'researcherDeposit.filesAndLinks.file.displayName.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.file.displayName.hint' | translate,
                },
                contentType: {
                    label: 'researcherDeposit.filesAndLinks.file.contentType.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.file.contentType.hint' | translate,
                },
                license: {
                    label: 'researcherDeposit.filesAndLinks.file.license.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.file.license.hint' | translate,
                },
                accessRights: {
                    label: 'researcherDeposit.filesAndLinks.file.accessRights.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.file.accessRights.hint' | translate,
                },
                description: {
                    label: 'researcherDeposit.filesAndLinks.file.description.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.file.description.hint' | translate,
                },
            };
        <mulo-context-frame
            #fileContextFrame
            (close)="handleFileFormClose()"
            (open)="handleFileFormOpen()"
            [isOpen]="filesFormMode() === 'edit' || filesFormMode() === 'add'"
            btnLabel="Add files"
        >
            <div class="form-wrap">
                @if (currentFile()) {
                    <div @heightInAnimation class="current-file">
                        <figure>
                            <mat-icon [svgIcon]="currentFile()?.type | fileTypeIcon" muloSvgViewbox></mat-icon>
                            <figcaption class="margin-left-sm">
                                <div>{{ currentFile()?.name }}</div>
                                @if (currentFile()?.type | fileTypeIcon: false; as typeText) {
                                    <div>
                                        {{
                                            'research.portal.filesAndLinks.file.typeText'
                                                | translate: { val0: typeText }
                                                | titlecase
                                        }}
                                    </div>
                                }
                                <div>{{ currentFile()?.size | fileSize }}</div>
                            </figcaption>
                        </figure>
                    </div>
                    <div class="replace-file">
                        <button (click)="fileInput.click()" color="primary" mat-button>
                            {{ 'research.portal.filesAndLinks.file.replace' | translate }}
                            <input
                                #fileInput
                                (click)="$event.stopPropagation()"
                                (input)="handleFileDrop($event?.target?.files)"
                                [multiple]="false"
                                type="file"
                            />
                        </button>
                    </div>
                } @else {
                    @if (filesFormMode() === 'add') {
                        <div @heightOutAnimation>
                            <em class="margin-left-xs margin-right-xs" translate>{{
                                'research.files.subtitle.part1.default.default'
                            }}</em>
                            <mulo-file-drop
                                (output)="handleFileDrop($event)"
                                [multiple]="false"
                                class="file-drop"
                                [multiFilesDropLabel]="'researcherDeposit.filesAndLinks.dropzone.multiple' | translate"
                                [singleFileDropLabel]="'researcherDeposit.filesAndLinks.dropzone.single' | translate"
                                [multiDropActionLabel]="'researcherDeposit.filesAndLinks.action.multiple' | translate"
                                [singleDropActionLabel]="'researcherDeposit.filesAndLinks.action.single' | translate"
                                [multiSelectBtnLabel]="'researcherDeposit.filesAndLinks.select.multiple' | translate"
                                [singleSelectBtnLabel]="'researcherDeposit.filesAndLinks.select.single' | translate"
                                [fileDropLimitMsg]="'researcherDeposit.filesAndLinks.limit.fileDrop' | translate"
                                [typeChangedLimitMsg]="'researcherDeposit.filesAndLinks.limit.typeChanged' | translate"
                                [confirmFileReplaceMsg]="'researcherDeposit.filesAndLinks.confirmReplace' | translate"
                                [invalidFilesHeaderLabel]="
                                    'researcherDeposit.filesAndLinks.invalidFilesHeader' | translate
                                "
                            ></mulo-file-drop>
                        </div>
                    }
                }
                @if (hasSubmitError) {
                    <div class="error" role="alert">
                        {{ 'research.portal.filesAndLinks.file.submitError' | translate }}
                    </div>
                }
                <form #fileForm (ngSubmit)="handleFileSubmit()" [formGroup]="filesForm">
                    <div @heightInAnimation class="fields-grouping">
                        <mat-form-field>
                            <mat-label>{{ fileLabels.displayName.label }}</mat-label>
                            <input autocomplete="off" formControlName="displayName" matInput />
                            @if (fileLabels.displayName.hint && fileLabels.displayName.hint !== ' ') {
                                <mat-hint>{{ fileLabels.displayName.hint }}</mat-hint>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <mat-label>{{ fileLabels.contentType.label }}</mat-label>
                            <mat-select #fileTypeElem formControlName="contentType">
                                <mat-option [value]="null"
                                    >--{{ 'research.settings.research.none' | customTranslate }}--</mat-option
                                >
                                @for (code of fileTypes(); track code) {
                                    <mat-option [value]="code">{{
                                        'AssetFileAndLinkTypesLabels.' + code | translate
                                    }}</mat-option>
                                }
                            </mat-select>
                            @if (fileLabels.contentType.hint && fileLabels.contentType.hint !== ' ') {
                                <mat-hint>{{ fileLabels.contentType.hint }}</mat-hint>
                            }
                        </mat-form-field>
                        <mat-form-field>
                            @let licenseLabel = 'researcherDeposit.filesAndLinks.file.license.label' | translate;
                            @let licenseHint = 'researcherDeposit.filesAndLinks.file.license.hint' | translate;
                            <mat-label>{{ licenseLabel }}</mat-label>
                            <mat-select formControlName="license">
                                <mat-option [value]="null"
                                    >--{{ 'research.settings.research.none' | customTranslate }}--</mat-option
                                >
                                @for (group of licenseTypes() | groupBy: 'category'; track group) {
                                    <mat-optgroup [label]="group.key">
                                        @for (license of group.value; track license) {
                                            <mat-option
                                                [value]="license.title"
                                                [matTooltip]="license.title + '.description' | translate"
                                                >{{ license.title + '.name' | translate }} ({{
                                                    license.title
                                                }})</mat-option
                                            >
                                        }
                                    </mat-optgroup>
                                }
                            </mat-select>
                            @if (licenseHint && licenseHint !== ' ') {
                                <mat-hint>{{ licenseHint }}</mat-hint>
                            } @else if (filesForm.enabled) {
                                <mat-hint>
                                    <a href="https://choosealicense.com/" target="_blank">{{
                                        'research.flicense.help' | customTranslate
                                    }}</a>
                                </mat-hint>
                            }
                        </mat-form-field>

                        <fieldset [disabled]="filesForm.get('access').disabled">
                            <legend>{{ fileLabels.accessRights.label }}</legend>
                            <esp-access-rights
                                [policyFieldControl]="filesForm.get('access')"
                                [embargoDateControl]="filesForm.get('accessRightsMoment')"
                                [noteFieldControl]="filesForm.get('accessRightsReason')"
                                [embargoPeriodEnabled]="false"
                                [localPolicyEnabled]="false"
                            ></esp-access-rights>
                            @if (fileLabels.accessRights.hint && fileLabels.accessRights.hint !== ' ') {
                                <div class="fieldset-hint-wrap">{{ fileLabels.accessRights.hint }}</div>
                            }
                        </fieldset>
                        <mat-form-field>
                            <mat-label>{{ fileLabels.description.label }}</mat-label>
                            <textarea formControlName="description" matInput maxlength="255" rows="1"></textarea>
                            @if (fileLabels.description.hint && fileLabels.description.hint !== ' ') {
                                <mat-hint>{{ fileLabels.description.hint }}</mat-hint>
                            }
                        </mat-form-field>
                    </div>
                    <div @heightInAnimation class="form-actions">
                        @if (fileSizeError) {
                            <span class="mat-error" role="alert">
                                {{ 'research.portal.filesAndLinks.file.size.validator.msg' | translate }}</span
                            >
                        }
                        <button
                            (click)="handleAddAnotherFile($event)"
                            [disabled]="
                                (filesFormMode() === 'add' && !currentFile()) ||
                                !filesForm?.valid ||
                                fileSizeError ||
                                submitInProgress()
                            "
                            mat-button
                        >
                            {{ 'research.portal.filesAndLinks.addAnother' | translate }}
                        </button>
                        <button
                            [disabled]="
                                (filesFormMode() === 'add' && !currentFile()) ||
                                !filesForm?.valid ||
                                fileSizeError ||
                                submitInProgress()
                            "
                            class="is-tight margin-left-sm"
                            mat-raised-button
                            type="submit"
                        >
                            {{
                                'research.portal.filesAndLinks.' + (filesFormMode() === 'add' ? 'add' : 'save')
                                    | translate
                            }}
                        </button>
                    </div>
                </form>
            </div>
        </mulo-context-frame>
        @if (files && files()?.length > 0) {
            <mulo-file-list displayMode="flat" listStyle="list">
                @for (file of files(); track $index) {
                    @let fileName = file.baseName || file.name;
                    <mulo-file-list-item
                        [baseName]="file.displayName ?? file.baseName"
                        [name]="file.name"
                        [disabled]="fileEditIndex() === $index"
                        [extension]="file.ext"
                        [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
                        [size]="file.size"
                        [type]="file.type"
                        [useListIcon]="true"
                        class="mulo-elevation-list-item"
                        listStyle="list"
                        [actions]="[
                            {
                                type: 'icon-btn',
                                icon: screenGtSm ? 'pencil' : null,
                                actionEvent: handleEditFileAction.bind(this, $index),
                                disabled: fileEditIndex() === $index,
                                labels: [
                                    'research.aria.icon.button.edit' | translate,
                                    'research.aria.edit.button' | translate: { value: fileName },
                                ],
                            },
                            {
                                type: 'icon-btn',
                                icon: screenGtSm ? 'close' : null,
                                actionEvent: removeFile.bind(this, $index),
                                disabled: fileEditIndex() === $index,
                                labels: [
                                    'research.delete.confirmation.confirm' | translate,
                                    'research.aria.delete.button' | translate: { value: fileName },
                                ],
                            },
                        ]"
                    >
                        @if (file.contentType) {
                            <span class="item-field">{{
                                'AssetFileAndLinkTypesLabels.' + file.contentType | translate
                            }}</span>
                        }
                        @if (file.description) {
                            <span [innerHTML]="file.description" class="item-field"></span>
                        }
                        @if (file.licenseCode) {
                            <span class="item-field">{{ file.licenseCode + '.name' | translate }}</span>
                        }
                        @if (file.access?.toLowerCase() === 'closed') {
                            <span class="file-lock" mulo-file-action>
                                <mat-icon svgIcon="lock"></mat-icon>
                            </span>
                        }
                    </mulo-file-list-item>
                }
            </mulo-file-list>
        }
    }

    <!-- LIST OF URLs-->
    @if (section === fieldType.Links) {
        @let linkLabels =
            {
                url: {
                    label: 'researcherDeposit.filesAndLinks.link.url.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.link.url.hint' | translate,
                },
                type: {
                    label: 'researcherDeposit.filesAndLinks.link.type.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.link.type.hint' | translate,
                },
                license: {
                    label: 'researcherDeposit.filesAndLinks.link.license.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.link.license.hint' | translate,
                },
                description: {
                    label: 'researcherDeposit.filesAndLinks.link.description.label' | translate,
                    hint: 'researcherDeposit.filesAndLinks.link.description.hint' | translate,
                },
            };
        <mulo-context-frame
            #linkContextFrame
            (close)="handleLinkFormClose()"
            (open)="handleLinkFormOpen()"
            [isOpen]="linksFormMode() === 'edit' || linksFormMode() === 'add'"
            btnLabel="Add links"
        >
            <form #linkForm (ngSubmit)="handleLinkSubmit()" [formGroup]="linksForm" class="padding-top-sm">
                <div class="fields-grouping">
                    <mat-form-field>
                        <mat-label>{{ linkLabels.url.label }}</mat-label>
                        <input
                            #urlInputElem
                            autocomplete="off"
                            formControlName="url"
                            id="linkUrl"
                            matInput
                            maxlength="4000"
                            type="url"
                        />
                        @if (linkLabels.url.hint && linkLabels.url.hint !== ' ') {
                            <mat-hint>{{ linkLabels.url.hint }}</mat-hint>
                        }
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ linkLabels.type.label }}</mat-label>
                        <mat-select #linkTypeElem formControlName="type">
                            <mat-option [value]="null"
                                >--{{ 'research.settings.research.none' | customTranslate }}--</mat-option
                            >
                            @for (code of linkTypes(); track code) {
                                <mat-option [value]="code">{{
                                    'AssetFileAndLinkTypesLabels.' + code | translate
                                }}</mat-option>
                            }
                            @if (linkLabels.type.hint && linkLabels.type.hint !== ' ') {
                                <mat-hint>{{ linkLabels.type.hint }}</mat-hint>
                            }
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>{{ linkLabels.license.label }}</mat-label>
                        <mat-select formControlName="license">
                            <mat-option [value]="null"
                                >--{{ 'research.settings.research.none' | customTranslate }}--</mat-option
                            >
                            @for (group of licenseTypes() | groupBy: 'category'; track group) {
                                <mat-optgroup [label]="group.key">
                                    @for (license of group.value; track license) {
                                        <mat-option
                                            [value]="license.title"
                                            [matTooltip]="license.title + '.description' | translate"
                                            >{{ license.title + '.name' | translate }} ({{ license.title }})</mat-option
                                        >
                                    }
                                </mat-optgroup>
                            }
                        </mat-select>
                        @if (linkLabels.license.hint && linkLabels.license.hint !== ' ') {
                            <mat-hint>{{ linkLabels.license.hint }}</mat-hint>
                        } @else if (linksForm.enabled) {
                            <mat-hint>
                                <a href="https://choosealicense.com/" target="_blank">{{
                                    'research.flicense.help' | customTranslate
                                }}</a>
                            </mat-hint>
                        }
                    </mat-form-field>

                    <mat-form-field class="margin-right-sm">
                        <mat-label>{{ linkLabels.description.label }}</mat-label>
                        <textarea formControlName="description" matInput maxlength="255" rows="1"></textarea>
                        @if (linkLabels.description.hint && linkLabels.description.hint !== ' ') {
                            <mat-hint>{{ linkLabels.description.hint }}</mat-hint>
                        }
                    </mat-form-field>
                </div>
                <div class="form-actions">
                    <button
                        (click)="handleAddAnotherLink($event)"
                        [disabled]="!linksForm?.valid || submitInProgress()"
                        mat-button
                    >
                        {{ 'research.portal.filesAndLinks.addAnother' | translate }}
                    </button>
                    <button
                        [disabled]="!linksForm?.valid || submitInProgress()"
                        class="is-tight margin-left-sm"
                        mat-raised-button
                        type="submit"
                    >
                        {{
                            'research.portal.filesAndLinks.' + (linksFormMode() === 'add' ? 'add' : 'save') | translate
                        }}
                    </button>
                </div>
            </form>
        </mulo-context-frame>
        @if (links && links()?.length > 0) {
            <mulo-file-list displayMode="flat" listStyle="list">
                @for (link of links(); track $index) {
                    @let linkName = link.displayName || link.title || link.url;
                    <mulo-file-list-item
                        [disabled]="linkEditIndex() === $index"
                        [moreBtnLabel]="'research.aria.output.list.menu.more.options' | translate"
                        [name]="linkName"
                        [useListIcon]="true"
                        class="mulo-elevation-list-item"
                        extension="url"
                        listStyle="list"
                        type="url"
                        [actions]="[
                            {
                                type: 'icon-btn',
                                icon: screenGtSm ? 'eye-outline' : null,
                                actionEvent: handleViewAction.bind(this, link, (files()?.length || 0) + $index),
                                disabled: linkEditIndex() === $index,
                                labels: [
                                    'research.portal.fulldisplay.file.view' | translate,
                                    'research.portal.fulldisplay.file.view.item' | translate: { value: linkName },
                                ],
                            },
                            {
                                type: 'icon-btn',
                                icon: screenGtSm ? 'pencil' : null,
                                actionEvent: handleEditLinkAction.bind(this, $index),
                                disabled: linkEditIndex() === $index,
                                labels: [
                                    'research.aria.icon.button.edit' | translate,
                                    'research.aria.edit.button' | translate: { value: linkName },
                                ],
                            },
                            {
                                type: 'icon-btn',
                                icon: screenGtSm ? 'close' : null,
                                actionEvent: removeLink.bind(this, $index),
                                disabled: linkEditIndex() === $index,
                                labels: [
                                    'research.delete.confirmation.confirm' | translate,
                                    'research.aria.delete.button' | translate: { value: linkName },
                                ],
                            },
                        ]"
                    >
                        @if (link.type) {
                            <span class="item-field">{{ 'AssetFileAndLinkTypesLabels.' + link.type | translate }}</span>
                        }
                        @if (link.description; as desc) {
                            <span [innerHTML]="desc" class="item-field"></span>
                        }
                        @if (link.license) {
                            <span class="item-field">{{ link.license + '.name' | translate }}</span>
                        }
                    </mulo-file-list-item>
                }
            </mulo-file-list>
        }
    }
}
